@use "Styles/includes/variables";
@use "Styles/mixins";
@use "Styles/components/buttons";
@use "Static/icons/icomoon/style.scss";

:host {

    .dropdown {
        position: relative;
        display: inline-block;

        &__menu {
            position: absolute;
            top: calc(100% + 4px);
            display: flex;
            flex-direction: column;
            width: auto;
            height: auto;
            padding: 8px 0;
            border-radius: 12px;
            border: 1px solid rgba(0,0,0,.15);
            background: mixins.get-color(bg, solid, primary);
            box-shadow: 0px 6px 24px 0px rgba(0, 0, 0, .08);

            &.is-hidden {
                display: none;
            }

            &--right {
                right: 0;
            }
            &--left {
                left: 0;
            }

        }

        &__menu-item {
            padding: 6px 20px;
            border: none;
            background-color: mixins.get-color(bg, solid, primary);
            color: mixins.get-color(text, tertiary);
            font-family: variables.$fontQuaternary;
            font-size: 14px;
            font-weight: 500;
            text-align: left;
            line-height: 20px;
            letter-spacing: .07px;
            cursor: pointer;
            outline: none;
            white-space: nowrap;

            &:hover {
                background-color: mixins.get-color(button, tertiary, bg, hover);
            }

            &:active,
            &:focus {
                outline: none;
            }
        }
    }
}
